import { Row } from '@tanstack/react-table';
import BigNumber from 'bignumber.js';

export const bigNumberSortBy =
  <T,>(key: keyof T) =>
  (a: Row<T>, b: Row<T>) => {
    const valueA = a.original[key];
    const valueB = b.original[key];

    if (BigNumber.isBigNumber(valueA) && BigNumber.isBigNumber(valueB)) {
      return valueA.comparedTo(valueB);
    }

    return 0;
  };
